function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Flex, FormLabel, Switch, Tooltip, Icon, icons } from '@tapresearch/ui/components';
import { Tooltips } from '../../../../shared/Tooltip/Tooltip.styled';
export var GroupAnswersSwitch = function(param) {
    var isGrouped = param.isGrouped, isSwitching = param.isSwitching, isDisabled = param.isDisabled, setIsGrouped = param.setIsGrouped, label = param.label, tooltipText = param.tooltipText;
    return /*#__PURE__*/ React.createElement(Flex, {
        "data-testid": "group-answers-switch-container",
        align: "center",
        lineHeight: "8",
        justify: "flex-end",
        mt: 5
    }, /*#__PURE__*/ React.createElement(FormLabel, {
        m: 0,
        fontWeight: "normal",
        fontSize: "sm",
        lineHeight: "1"
    }, /*#__PURE__*/ React.createElement(Flex, _object_spread({
        align: "center"
    }, isDisabled && {
        color: 'gray.400'
    }), tooltipText && /*#__PURE__*/ React.createElement(Tooltip, _object_spread_props(_object_spread({}, Tooltips.Base), {
        shouldWrapChildren: true,
        label: tooltipText,
        placement: "left"
    }), /*#__PURE__*/ React.createElement(Icon, {
        wrapAs: Flex,
        icon: icons.md.InfoOutline,
        boxSize: 4,
        mr: 1
    })), label)), /*#__PURE__*/ React.createElement(Flex, {
        w: "45px",
        justify: "flex-end"
    }, /*#__PURE__*/ React.createElement(Switch, {
        "data-testid": "group-answers-switch",
        isChecked: isGrouped,
        isDisabled: isSwitching || isDisabled,
        onChange: function() {
            return setIsGrouped(!isGrouped);
        },
        ml: 2
    })));
};
